import { Subscription } from '@urc-ui/store/api/subscriptions/types';

export interface TaktEventProps {
  readonly eventName: TAKT_EVENT;
  readonly source: TAKT_EVENT_SOURCE;
}

export interface TaktLoggerProps {
  // We will get subscription from subscription table
  readonly subscription?: Subscription;
  readonly subscriptionId?: string;
}

export interface TaktSubscriptionEvent {
  readonly eventName: string;
  readonly source: string;
  readonly programType: string | null;
  readonly reportType: string;
  readonly taktReportType: string;
  readonly reportUnit: string | null;
  readonly reportPeriod: string;
  readonly subscriptionType: string;
  readonly subscriptionFrequency: string;
  readonly emailCount: number;
  reportId?: string;
  readonly subscriptionId?: string;
  readonly marketplaceIds: string[] | null;
  readonly currencyOfVisualization?: string | null;
  readonly isMta?: boolean | null;
}

export type TaktRequestModel = (TaktEventProps | TaktSubscriptionEvent) & { readonly namespace: string };

export const enum TAKT_EVENT {
  RUN_REPORT = 'run-report',
  SCHEDULE_REPORT = 'schedule-report',
  SEARCH_REPORTS = 'search-reports',
  DOWNLOAD_REPORT = 'download-report',
  OPEN_REPORT_DETAILS = 'open-report-details',
  COPY_REPORT = 'copy-report',
  DELETE_REPORT = 'delete-report',
  UPDATE_REPORT = 'update-report',
  TOGGE_RECURRING_REPORT = 'toggle-recurring-report',
  CREATE_REPORT = 'create-report',
  OPEN_ADVERTISER_ORDER = 'open-advertiser-order',
  PAGINATION_CHANGE = 'pagination-change',
  COLUMN_VISIBILITY_TOGGLED = 'column-visibility-toggled',
  COLUMN_SORT_TOGGLED = 'column-sorting-toggled',
  FILTERS_UPDATED = 'filters-updated'
}

export const enum TAKT_EVENT_SOURCE {
  HOME_PAGE = 'manage-reports-page',
  NEW_REPORT_PAGE = 'new-report-page',
  SUBSCRIPTION_TABLE = 'subscription-table',
  REPORT_HISTORY = 'report-history',
  REPORT_SETTINGS = 'report-settings',
  VIEW_SUBSCRIPTION_PAGE = 'view-subscription-page'
}

export const CONTEXT_NAME_SPACE = 'urc';

export const enum ADVERTISER_NAMESPACE {
  ADSP = 'ADSP',
  SSPA = 'SSPA'
}
